import z from 'zod';
import { CreatorContentSchema } from '../creator/schema';
import { SOURCE_PLATFORM_TYPE } from '../public-filter';

export const savedCreatorListSchema = z.object({
  id: z.string(),
  title: z.string(),
  total_count: z.number(),
  created_at: z.string(),
});

export const creatorsInListSchema = z.object({
  id: z.string(),
  platform: z.enum(SOURCE_PLATFORM_TYPE),
  username: z.string(),
  nickname: z.string(),
  profile_url: z.string(),
  profile_image_url: z.string(),
  bio: z.string(),
  email: z.string().email().nullable().optional(),
  followers: z.number(),
  recent_avg_er: z.number(),
  post_categories: z.array(z.string()),
  matched_posts: z.array(CreatorContentSchema).optional(),
  excluded_at: z.string().optional(),
  demographics: z
    .object({
      age: z.array(z.string()),
      gender: z.array(z.string()),
      race: z.array(z.string()),
      location: z.array(z.string()),
      language: z.array(z.string()),
    })
    .optional(),
});

export const creatorsListSchema = z.object({
  creators: z.array(creatorsInListSchema),
  page: z.number(),
  total_pages: z.number(),
  total_count: z.number(),
});

export const creatorsListRequestSchema = z.union([
  z.object({
    page: z.number().min(1).optional(),
    limit: z.number().min(1).max(100).default(20).optional(),
  }),
  z.null(),
]);

export const addCreatorsSchema = z.union([
  z.object({
    search_id: z.string(),
    selected_all: z.boolean(),
  }),
  z.object({
    search_id: z.string(),
    creator_ids: z.array(z.string()),
  }),
]);

export const removeCreatorsSchema = z.union([
  z.object({
    search_id: z.string(),
    selected_all: z.boolean(),
  }),
  z.object({
    creator_ids: z.array(z.string()),
  }),
]);

export const savedListOutreachChannelSchema = z.enum(['email', 'tiktok_dm']);

export const savedListOutreachStatusSchema = z.enum([
  'not_contacted',
  'queued',
  'sent',
  'replied',
  'interested',
  'confirmed',
  'declined',
]);

export const savedListOutreachStatusItemSchema = z.object({
  creator_id: z.string(),
  channel: savedListOutreachChannelSchema,
  status: savedListOutreachStatusSchema,
  updated_at: z.string().optional(),
});

export const savedListOutreachStatusesResponseSchema = z.object({
  statuses: z.array(savedListOutreachStatusItemSchema),
});

export const updateSavedListOutreachStatusRequestSchema = z.object({
  creator_id: z.string(),
  channel: savedListOutreachChannelSchema,
  status: savedListOutreachStatusSchema,
});

export const savedListOutreachMessageSchema = z.object({
  subject: z.string().optional(),
  body: z.string(),
});

export const savedListOutreachFollowUpSchema = z.object({
  enabled: z.boolean(),
  subject: z.string().optional(),
  body: z.string().optional(),
  delay_days: z.number().int().min(1).optional(),
});

export const createSavedListOutreachQueueRequestSchema = z.object({
  channel: savedListOutreachChannelSchema,
  creator_ids: z.array(z.string()).min(1),
  sequence_name: z.string(),
  initial_message: savedListOutreachMessageSchema,
  follow_up: savedListOutreachFollowUpSchema.optional(),
  ai_replies_enabled: z.boolean().optional(),
});

export const createSavedListOutreachQueueResponseSchema = z.object({
  queue_id: z.string(),
  status: z.literal('created'),
  recipient_count: z.number(),
});

export const savedListCampaignDraftCreatorRequestSchema = z.object({
  creator_ids: z.array(z.string()).min(1),
});

export const savedListCampaignDraftCreatorSchema = z.object({
  id: z.string(),
  username: z.string(),
  platform: z.enum(SOURCE_PLATFORM_TYPE).nullish(),
});

export const savedListCampaignDraftCreatorsResponseSchema = z.object({
  creators: z.array(savedListCampaignDraftCreatorSchema),
});
